var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.0003 14H44.3337V35H14.0003V39.6666C14.0003 40.95 15.0503 42 16.3337 42H42.0003L51.3337 51.3333V16.3333C51.3337 15.05 50.2837 14 49.0003 14ZM39.667 28V6.99996C39.667 5.71663 38.617 4.66663 37.3337 4.66663H7.00033C5.71699 4.66663 4.66699 5.71663 4.66699 6.99996V39.6666L14.0003 30.3333H37.3337C38.617 30.3333 39.667 29.2833 39.667 28Z",
    fill: "#1F2F3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForumIcon);
export default __webpack_public_path__ + "static/media/forum-icon.4112fa6833ada42cbbb7594dfd44e608.svg";
export { ForwardRef as ReactComponent };